var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCallStatusEnd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 30 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 14.5,
    r: 12.5,
    fill: "#E74C3C",
    stroke: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M8.147 12.66c.815-.815 1.913-1.45 3.26-1.89 1.245-.406 2.66-.62 4.094-.618 1.434 0 2.848.215 4.093.621 1.348.44 2.446 1.074 3.26 1.889.527.527.545 1.528.53 1.935-.025.584-.178 1.39-.525 1.737-.173.172-.49.262-.995.282a8.735 8.735 0 01-1.346-.073c-.303-.039-1.838-.248-2.257-.667-.343-.344-.194-.97-.035-1.634.061-.257.125-.522.148-.737.024-.229-.006-.305-.013-.32-1.524-.65-4.19-.65-5.715.001-.008.013-.04.088-.013.32.024.215.086.48.147.738.158.663.307 1.29-.036 1.633-.42.42-1.954.63-2.259.668a8.37 8.37 0 01-1.346.073c-.504-.018-.82-.107-.993-.28-.347-.347-.501-1.153-.525-1.738-.017-.408-.001-1.412.526-1.94z"
  }))));
}

export default SvgCallStatusEnd;